<template>
  <b-nav-item @click.prevent="getRepairHistory" v-b-tooltip.hover="'Repair History'">
    <b-icon-clock-history variant="light" class="menu-icon" />
  </b-nav-item>
</template>

<script>
//---- components ---------
//---- mixins -------------
import DSCommonJS from "@/app/components/callcenter/service-sessions/ds-common.js";
//---- services -----------
//---- 3rd-parties --------
import { BIconClockHistory } from "bootstrap-vue";

export default {
  mixins: [DSCommonJS],
  components: {
    BIconClockHistory
  },
  methods: {
    getRepairHistory() {
      //clear the tabs
      this.clearTabs();
      // clear sort filter
      this.clearSortfilter();
      this.$store
        .dispatch("dsDashboard/addDsDashboardTab", {
          tabTitle: "label.dsCaseStatus.repairHistory",
          tabId: "Default"
        })
        .then(() => {
          this.$store
            .dispatch("dsDashboard/getDSRepairHistoryInit")
            .then(() => {
              // clear the sessions data
              this.clearSessionsData();
              // clear the filter value
              this.clearSearchFilterValue();
              // set the "DS_REPAIR_HISTORY" view
              this.setCurrentTemplateView("DS_REPAIR_HISTORY");
              this.$store.getters["projectData/currentQuest"].name =
                "SERVICE_SESSIONS";
              this.safeRouterPush({
                  path: "/ds/repair-history",
                  hash: this.updateHash("RepairHistory")
                });
            });
        });
    },
  }
};
</script>